import React  , { Component } from 'react'
import LazyLoad from 'react-lazyload';
import { withRouter } from 'react-router-dom'
import {  HomeSlider,
          HomeTitle,
          Img,
          ResponsiveYouTubeIframe,
          GallerSideBarItem      } from '../../../Components/UI/UI'

import {getWeather} from '../../../Utility/Utility'


import Popup from "reactjs-popup";


import Menu from '../../../Components/Menu/Menu'
import Footer from '../../../Components/Footer/Footer'

import "../Gallery.css"

class GalleryJA extends Component {

  state = {
   
    telAvivWeather : 0,
    waterTemp : 0,
    jerusalemWeather : 0,
    open: false , 
    id : null 


  } 


  openModal = (id) => {
    this.setState({ 
        open: true ,
        id : id
    });
  };
  closeModal = () => {
    this.setState({ open: false });
  };



  componentDidMount () {

    getWeather((Weather)=>{
      
      console.log("Weather", Weather);
      this.setState({
        telAvivWeather : Weather.telAvivWeather,
        waterTemp : Weather.water_temp,
        jerusalemWeather : Weather.jerusalemWeather,
      })

      
    });
    

     
  }
  
 
   
  render(){
     let count  = 26;
    let gallery = [];
    for (var i = 1; i <= count; i++) {
      gallery.push({
        id : i
      });
    };

    const galleryHtml = gallery.map( ( o , i )=> {

        let cssClass = 'col col-30';
        if (  i % 3 ===  0 ) {
          cssClass += " first ";
        }
       const imgPath = "gallery/JA/small/" +o.id +".jpg";
       return <div className={cssClass}  onClick={ () => {
                  this.openModal(o.id)
               }}> 
                <Img desktopImg={imgPath} />
              </div>
    })
   const bigImgPath = "gallery/JA/big/" +this.state.id +".jpg";
    return(
      <div className="page align-center page-Gallery inner-post">
        <Menu />
        <section className="post-data">
          <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />
          <div className="container content-container">
              <div className="col col-75">
                <div className="inner"> 
                  <HomeTitle>
                    jerusalem
                  </HomeTitle>
                  <div className="clear"></div>
                 
                  <div className="clear"></div>

                  <div className="gallery-html-wrapper">
                  {galleryHtml}
                  </div>

                </div>
              </div>

             
              <div className="clear"></div>
          </div>
          

          <Popup
            open={this.state.open}
            closeOnDocumentClick
            onClose={this.closeModal}
          >
            <div className="modal">
              <a className="close" onClick={this.closeModal}>
                &times;
              </a>
              <Img desktopImg={bigImgPath} /> 
            </div>
          </Popup>

        </section>
        <Footer />
      </div>
    )
  }

}



export default withRouter(GalleryJA)


// WEBPACK FOOTER //
// ./src/Pages/Gallery/JA/GalleryJA.js